import usePosOrderCurrentAction from "@/shared/atoms/usePosOrderCurrentAction";
import usePosOrderRemarkAtom from "@/shared/atoms/usePosOrderRemarkAtom";
import { useSetModal } from "@/shared/atoms/useModal";
import useActionClick from "./useActionClick";
import PosMenuBottomActionButton, {
  PosMenuAction,
} from "../PosMenu/PosMenuBottomActionButton";
import { useTranslation } from "react-i18next";
import { CurrentActionTypes } from "@/shared/atoms/usePosOrderCurrentAction";
import Ellipsis from "../Base/Ellipsis";

const useAddRemarkAction = (): PosMenuAction => {
  const { t } = useTranslation();
  const [remark, setRemark] = usePosOrderRemarkAtom();
  const setModal = useSetModal();

  return {
    name: "addRemarkModal" as CurrentActionTypes,
    label: (
      <div className="text-[1.4rem] max-w-[20rem]">
        {t("posOrders.addNote")}
        {remark && (
          <Ellipsis fontWeight="600" fontSize="1.4rem" color="var(--error)">
            {remark}
          </Ellipsis>
        )}
      </div>
    ),
    deleteAction: () => setRemark(undefined),
    hasDeleteAction: Boolean(remark),
    set: () => setModal("posOrderRemark"),
    instantSet: true,
    filtered: false,
    disabled: false,
    iconVariant:"pencil",
  };
};

const AddRemarkAction = () => {
  const [currentAction] = usePosOrderCurrentAction();
  const action = useAddRemarkAction();
  const handleClick = useActionClick(action);

  return (
    <PosMenuBottomActionButton
      action={action}
      isSelected={currentAction?.name === action.name}
      onClick={handleClick}
    />
  );
};

export default AddRemarkAction;
